// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .dropdown-item.active {
  background-color: #daebbf !important;
  color: #007834 !important;
}
::ng-deep .dropdown-item.active h5 {
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-input-autocomplete/s1-input-autocomplete.component.scss"],"names":[],"mappings":"AAEA;EACE,oCAAA;EACA,yBAAA;AADF;AAEE;EACE,gBAAA;AAAJ","sourcesContent":["@import '../../../app/shared/styles/app/variables';\n\n::ng-deep .dropdown-item.active {\n  background-color: $serravalle-accent-lighter !important;\n  color: $serravalle-primary-dark !important;\n  h5 {\n    font-weight: 700;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
